module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', {
    staticClass: "card-name"
  }, [_vm._v("card name")])])], 1), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "club-card"
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('h2', {
    staticClass: "card-title"
  }, [_vm._v("What is Sk Club")]), _vm._v(" "), _c('p', {
    staticClass: "card-teaser"
  }, [_vm._v("Lorem ipsum dolor sit, amet consectetur adipisicing elit. Voluptas, deserunt esse? Adipisci est ipsum provident voluptas asperiores id eius a, voluptate quod, recusandae rem. Quaerat quibusdam consequatur voluptatem voluptas exercitationem?")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("get more info")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cf762dc","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/club-loyalty/club-loyalty-listing/club-loyalty-listing.vue
// module id = 894
// module chunks = 0